import React from "react";
import type { LinkProps } from "@shopify/polaris";
import { Link } from "@shopify/polaris";
import { addShopParamToUrl } from "../../helper_functions/utils";

export default function HorseLink({
  url,
  children,
  ...rest
}: LinkProps): React.ReactElement {
  url = addShopParamToUrl(url);

  return <Link url={url} {...rest}>{children}</Link>;
}